import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module300 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              3.0.0 Self-Assessment Cases
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>
          <section>
            <p className="mt-5">
              For Module 3, you will need to view each case in MIM Referring.
              This software was used in Module 2. Below is a reminder on how to
              download and set it up.
            </p>
            <h2 className="h5 b mt-4">MIM Referring Setup Instructions</h2>
            <ol>
              <li>
                Please click the appropriate link to download the MIM Referring
                software.*
                <ul>
                  <li><a href="https://downloads.mimsoftware.com/MIM7.4.2_buildOA10-09.exe" target="_blank" className="orange b" rel="noreferrer">PC: MIM Referring software download link</a></li>
                  <li><a href="https://downloads.mimsoftware.com/MIM7.4.2_buildOA10-09.dmg" target="_blank" className="orange b" rel="noreferrer">Mac: MIM Referring software download link</a></li>
                </ul>
              </li>
              <li>
                For PC users, click “Run” to begin the download and follow the
                installation instructions. For Mac users, click on the
                downloaded .dmg file and then click on the PKG file to begin the
                installation.
                <ul>
                  <li>
                    Use the password “clarke” when prompted to enter a password
                    for the encrypted file
                  </li>
                </ul>
              </li>
              <li>
                Once the installation completes, click “Close” as you do not
                need to launch or log into the MIM Referring software at this
                time.
              </li>
              <li>
                On the following screens, direct links will be provided to cases
                for your review. If you are prompted for a username and password
                after clicking on the direct links to the cases, enter:
              </li>
            </ol>
            <p>
              <strong>E-mail address:</strong> amyvidtraining@amyvidtraining.com
              <br />
              <strong>Password (case sensitive):</strong> Amyvid2012
            </p>
            <p className="b">
              Do not close this training window when you navigate to the MIM
              Referring software; you will need both windows open at the same
              time.
            </p>
            <p className="fz-small">
              *This training uses MIM Referring software. As there are
              differences between the commercially available software, please
              consult your specific software manufacturer for more detailed
              training and orientation.
            </p>
            <h2 className="h5 b mt-4 text-center">
              Module 3 consists of 20 cases and 3 steps for each case.
            </h2>
            <div className="row mb-5 mt-4">
              <div className="col-sm-12 col-md-8 offset-md-2">
                <div className="row">
                  <div className="column-300 text-center ps-4 pe-4">
                    <div
                      className="conatiner-300 pt-3 pb-3"
                      style={{ border: "solid 1px" }}
                    >
                      <p className="h3 b black">
                        STEP
                        <br />
                        <span className="h1 b">1</span>
                      </p>
                      <div className="icon-box-300-1 d-flex align-items-center justify-content-center">
                        <svg
                          width="37"
                          height="32"
                          viewBox="0 0 37 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_634_26473)">
                            <path
                              d="M0.28125 16C0.28125 10.475 4.75625 6 10.2812 6H14.2812C15.3875 6 16.2812 6.89375 16.2812 8C16.2812 9.10625 15.3875 10 14.2812 10H10.2812C6.96875 10 4.28125 12.6875 4.28125 16C4.28125 19.3125 6.96875 22 10.2812 22H14.2812C15.3875 22 16.2812 22.8937 16.2812 24C16.2812 25.1063 15.3875 26 14.2812 26H10.2812C4.75625 26 0.28125 21.525 0.28125 16ZM36.2812 16C36.2812 21.525 31.8062 26 26.2812 26H22.2812C21.175 26 20.2812 25.1063 20.2812 24C20.2812 22.8937 21.175 22 22.2812 22H26.2812C29.5938 22 32.2812 19.3125 32.2812 16C32.2812 12.6875 29.5938 10 26.2812 10H22.2812C21.175 10 20.2812 9.10625 20.2812 8C20.2812 6.89375 21.175 6 22.2812 6H26.2812C31.8062 6 36.2812 10.475 36.2812 16ZM12.2812 14H24.2812C25.3875 14 26.2812 14.8938 26.2812 16C26.2812 17.1062 25.3875 18 24.2812 18H12.2812C11.175 18 10.2812 17.1062 10.2812 16C10.2812 14.8938 11.175 14 12.2812 14Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath>
                              <rect
                                width="36"
                                height="32"
                                fill="white"
                                transform="translate(0.28125)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <p className="mt-5 mb-5 ps-2 pe-2">
                        Follow the link to each case; this will open in MIM
                        Referring
                      </p>
                    </div>
                  </div>
                  <div className="column-300 ps-4 pe-4 text-center">
                    <div
                      className="conatiner-300 pt-3 pb-3"
                      style={{ border: "solid 1px" }}
                    >
                      <p className="h3 b black">
                        STEP
                        <br />
                        <span className="h1 b orange">2</span>
                      </p>
                      <div className="icon-box-300-2 d-flex align-items-center justify-content-center">
                        <svg
                          width="29"
                          height="32"
                          viewBox="0 0 29 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_634_26480)">
                            <path
                              d="M4.28125 2C2.075 2 0.28125 3.79375 0.28125 6V26C0.28125 28.2062 2.075 30 4.28125 30H24.2812C26.4875 30 28.2812 28.2062 28.2812 26V6C28.2812 3.79375 26.4875 2 24.2812 2H4.28125ZM8.89375 10.3313C9.3875 8.9375 10.7125 8 12.1938 8H15.8375C18.0187 8 19.7812 9.76875 19.7812 11.9438C19.7812 13.3563 19.025 14.6625 17.8 15.3687L15.7812 16.525C15.7688 17.3375 15.1 18 14.2812 18C13.45 18 12.7812 17.3313 12.7812 16.5V15.6562C12.7812 15.1187 13.0688 14.625 13.5375 14.3562L16.3062 12.7688C16.6 12.6 16.7812 12.2875 16.7812 11.95C16.7812 11.425 16.3562 11.0063 15.8375 11.0063H12.1938C11.9813 11.0063 11.7938 11.1375 11.725 11.3375L11.7 11.4125C11.425 12.1938 10.5625 12.6 9.7875 12.325C9.0125 12.05 8.6 11.1875 8.875 10.4125L8.9 10.3375L8.89375 10.3313ZM12.2812 22C12.2812 21.4696 12.492 20.9609 12.867 20.5858C13.2421 20.2107 13.7508 20 14.2812 20C14.8117 20 15.3204 20.2107 15.6955 20.5858C16.0705 20.9609 16.2812 21.4696 16.2812 22C16.2812 22.5304 16.0705 23.0391 15.6955 23.4142C15.3204 23.7893 14.8117 24 14.2812 24C13.7508 24 13.2421 23.7893 12.867 23.4142C12.492 23.0391 12.2812 22.5304 12.2812 22Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_634_26480">
                              <rect
                                width="28"
                                height="32"
                                fill="white"
                                transform="translate(0.28125)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <p className="mt-5 mb-5 ps-2 pe-2">
                        Answer the question posed
                      </p>
                    </div>
                  </div>
                  <div className="column-300 ps-4 pe-4 text-center">
                    <div
                      className="conatiner-300 pt-3 pb-3"
                      style={{ border: "solid 1px" }}
                    >
                      <p className="h3 b black">
                        STEP
                        <br />
                        <span className="h1 b gray">3</span>
                      </p>
                      <div className="icon-box-300-3 d-flex align-items-center justify-content-center">
                        <svg
                          width="25"
                          height="32"
                          viewBox="0 0 25 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_634_26464)">
                            <path
                              d="M4.84375 2.4372C3.91875 1.86845 2.75625 1.8497 1.8125 2.38095C0.86875 2.9122 0.28125 3.9122 0.28125 4.9997V26.9997C0.28125 28.0872 0.86875 29.0872 1.8125 29.6184C2.75625 30.1497 3.91875 30.1247 4.84375 29.5622L22.8438 18.5622C23.7375 18.0184 24.2812 17.0497 24.2812 15.9997C24.2812 14.9497 23.7375 13.9872 22.8438 13.4372L4.84375 2.4372Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_634_26464">
                              <rect
                                width="24"
                                height="32"
                                fill="white"
                                transform="translate(0.28125)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <p className="mt-5 mb-5 ps-2 pe-2">
                        Watch the video explaining each scan and the correct
                        answer
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-3/isi", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-3/module-3-0-1", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module300;
